// Generated by https://quicktype.io


export interface LoginResponseModel {
	username: string;
	firstName: string;
	lastName: string;
	email: string;
	roles: string[];
	authorities: string[];
	access_token: string;
	expires_in: number;
}

export interface LoginRequestModel {
	password?: string;
	username?: string;
	manufacturer: string;
	model: string;
	deviceUniqueIdentifier: string;
	loginType?: any;
	notificationType?: any;
	notificationToken?: string;
	passcode?: string;
	phoneNumber?:string;
}
export interface LoginV2RequestModel {
	passcode: string;
	phoneNumber: string;
	manufacturer: string;
	model: string;
	deviceUniqueIdentifier: string;
	loginType?: any;
	notificationType?: any;
	notificationToken?: string;
	password?: string;
	username?:string;
}

export enum NotificationType {
	FIREBASE = 'FIREBASE'
}

// Generated by https://quicktype.io

export interface OtpLoginResponse {
	code: string;
	description: string;
	responseCode: string;
	responseMessage: string;
	message: string;
	activationToken: string;
	tokenData: TokenData;
	ussdCode: string;
}

export interface TokenData {
	username: string;
	firstName: string;
	lastName: string;
	email: string;
	roles: string[];
	authorities: string[];
	access_token: string;
	expires_in: number;
}

export const MockUser = {
	username: 'samadi_aggregator',
	firstName: 'Solomon',
	lastName: 'Amadi',
	email: 'sohlowmawn@gmail.com',
	roles: [
		'MONNIFY_AGENCY_BANKING_AGGREGATOR'
	],
	authorities: [
		'mab_fo_aggregator_profile',
		'mab_fo_update_agents',
		'mab_fo_retrieve_agent_terminals',
		'mab_fo_view_nuban_account_statement',
		'mab_fo_view_aggregator_transaction_data',
		'mab_fo_validate_terminal_serial_number',
		'mab_fo_swap_agent_terminals',
		'mab_fo_view_aggregator_terminal_assignment_requests',
		'mab_fo_view_agent_kyc_verification',
		'mab_fo_view_aggregator_dashboard',
		'mab_fo_update_terminal_assignment_requests',
		'mab_fo_view_aggregator_transactions',
		'mab_fo_view_wallet_transaction',
		'mab_fo_get_agents_location',
		'mab_fo_view_aggregator_requests',
		'mab_fo_aggregator_manage_loans',
		'mab_fo_update_password',
		'mab_fo_view_agent_terminals',
		'mab_fo_approve_agents',
		'mab_fo_view_super_aggregator_commission',
		'mab_fo_view_agents',
		'mab_fo_process_aggregator_requests',
		'mab_fo_validate_bvn',
		'mab_fo_manage_agents_location',
		'mab_fo_wallet_cashout',
		'mab_otp_generate_ussd_otp_code',
		'mab_fo_manage_agent_kyc_verification',
		'mab_fo_view_wallet',
		'mab_fo_fund_wallet',
		'mab_fo_view_cashout_transactions',
		'mab_fo_validate_bank_account',
		'mab_fo_add_agents',
		'mab_fo_assign_agent_terminals'
	],
	access_token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.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.Y4Yvinxykt1N9kn454rylrGHSjCF30zDlrQush2W96NFw0VWdBGpO0dFlqNge45gwptyMz1EiW8BDyswO4R81HsfQM-vu6TmFYxMCEnatRXsRUMxvEZgivngrk-6sHaz7diLAm36qBv4RWcWB7JqiW7dSmF7yhBLTVxF5LsTaN_X0dHty9nOTbrPEfgPwNoTqRMd6MzmYoCn7Bp-ysNGACIu6dT1YEW03xnZ2BHAYd6_cTXLdXvEMIMJtH7FAieufk3gKnCq43Hm8J-rFOWyWikPzPcIcOBwX_gYUZjT3f_jc0YMLUfAwXUEiR_hEVfee4kmteMNrhF--4CJHTxLJg',
	expires_in: 86399
};
